import { graphql } from '@/generated/gql';

export const SOURCING_CASE_NEGOTIATION_SETTINGS_QUERY = graphql(/* GraphQL */ `
  query SourcingCaseNegotiationSettingsQuery($id: UUID!) {
    tesseract {
      sourcingCase(id: $id) {
        id
        status
        isNegotiationEnabled
        isSupplierUploadAllowed
        negotiationOptions {
          id
          initiatedBy
          negotiationObjective
          supplierInteractionMode
        }
        negotiationStrategy {
          id
          boundaryRules {
            base
            lower
            upper
          }
          useHistoricNegotiationData
          useHistoricTenderData
        }
      }
    }
  }
`);
